<template>
<div class="page page_xiaofei page_income page_park">
    <div class="top">
        <div class="txt">等级规则</div>
    </div>
    <div class="rank">
        <div class="guize" v-for="(item,index) in dataList" :key="index">会员等级{{ item.name }},折扣{{ item.discount +'%'}},消费满{{ item.pay_money +'元'}}可升级</div>
        <!-- <div class="guize">积分等级某某某</div> -->
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
			token: null,
			park_uuid: this.$route.query.park_uuid,
			dataList: []
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '等级规则'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getDate()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getDate()
		}
		
    },
    methods: {
		// 获取园区等级规则
		getDate(){
			var params = {
				token: this.token,
				park_uuid: this.park_uuid,
                page: 1,
                size: 100
			}
			this.$api.park.levelrule(params).then(res=>{
				if(res.code == 200){
					this.dataList = res.result.list
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
